import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OrderScan } from '@classes/order/orderScan';
import { TemperaturesService } from '@services/temperatures.service';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-order-step-scans-table',
  templateUrl: './order-step-scans-table.component.html',
  styleUrls: ['./order-step-scans-table.component.scss']
})
export class OrderStepScansTableComponent implements OnInit {
  @Input() scans: OrderScan[] = [];
  @Input() allScans: OrderScan[] = [];
  @Input() orderStartDate: Date;
  @Input() clientId: string;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns: string[] = ['code', 'productType', 'scannedOn', 'description', 'identifier', 'tag', 'actions'];
  dataSource: MatTableDataSource<OrderScan>;

  isLoadingKoovea = false;

  constructor(
    private temperaturesSrv: TemperaturesService,
    private uiSrv: UiService
  ) { }

  ngOnInit(): void {
    this.initTable();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'productType': return item.container.productType.name;
        case 'description': return item.container.description;
        case 'identifier': return item.container.identifier;
        case 'tag': return item.container.tag;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
  }

  initTable(): void {
    this.scans = this.scans.sort((a, b) => a.container.description.localeCompare(b.container.description));
    this.dataSource = new MatTableDataSource(this.scans);
  }

  downloadKooveaPDF(scan: OrderScan) {
    let firstScan = [...this.allScans].find(s => s.container.id === scan.container.id);

    let lastScan = [...this.allScans].reverse().find(s => s.container.id === scan.container.id);

    this.isLoadingKoovea = true;

    this.temperaturesSrv.downloadKooveaPDF(firstScan.scannedOn, lastScan.scannedOn, scan.container.tag, this.clientId).subscribe(
      ({
        next: (data) => {
          this.isLoadingKoovea = false;
          this.uiSrv.loadingStateChanged.next(false);
        },
        error: (error) => {
          this.isLoadingKoovea = false;
          this.uiSrv.loadingStateChanged.next(false);
        }
      }));
  }

}
